import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import PasswordControl from '../../../lib/ui/PasswordControl'

export default class ChangeCredentials {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Uw PRIM wachtwoord wijzigen',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      }]
    })

    let checkCredentials = () => {
      if (!this.oldpassword.getValue() || !this.password1.getValue() || !this.password2.getValue()) {
        alert('Vul uw oude en nieuwe wachtwoord in.')
        return
      }      

      if (this.password1.getValue() !== this.password2.getValue()) {
        alert('Uw nieuwe wachtwoorden komen niet overeen. Corrigeer uw invoer en probeer het opnieuw.')
        return
      }

      if (this.oldpassword.getValue() === this.password1.getValue()) {
        alert('Uw oude en nieuwe wachtwoord mogen niet overeen komen. Kies een ander wachtwoord.')
        return
      }

      if (this.password1.getValue().length < 12) {
        alert('Uw nieuwe wachtwoord moet tenminste 12 tekens lang zijn vanwege veiligheid. Kies een langer wachtwoord.')
        return
      }

      let lowercase = new RegExp(/[a-z]/g)

      if (!lowercase.test(this.password1.getValue())) {
        alert('Uw nieuwe wachtwoord moet tenminste 1 kleine letter bevatten. Probeer opnieuw.')
        return
      }

      let uppercase = new RegExp(/[A-Z]/g)

      if (!uppercase.test(this.password1.getValue())) {
        alert('Uw nieuwe wachtwoord moet tenminste 1 hoofdletter bevatten. Probeer opnieuw.')
        return
      }

      let digits = new RegExp(/\d/g)

      if (!digits.test(this.password1.getValue())) {
        alert('Uw nieuwe wachtwoord moet tenminste 1 cijfer bevatten. Probeer opnieuw.')
        return
      }

      let special = new RegExp(/\W/g)

      if (!special.test(this.password1.getValue())) {
        alert('Uw nieuwe wachtwoord moet tenminste 1 speciaal teken bevatten. Probeer opnieuw.')
        return
      }

      window.PRIM.dataAccess.isCurrentPassword(this.oldpassword.getValue()).then((status) => {
        switch (status) { 
          case 'invalid':
            alert('Uw oude wachtwoord is onjuist. Probeer het opnieuw.')
            return
          default:
            window.PRIM.dataAccess.setCredentials(null, this.oldpassword.getValue())
            window.PRIM.dataAccess.externalChangePassword(this.password1.getValue()).then((status) => {
              switch (status) { 
                default:
                alert('Uw PRIM account wachtwoord is gewijzigd. Log voortaan in met dit nieuw gekozen wachtwoord.')
                window.PRIM.dataAccess.setCredentials(null, this.password1.getValue())
                window.PRIM.session.password = this.password1.getValue()            
                break
              }
            }, (e) => {
              alert('Uw PRIM account wachtwoord kon niet gewijzigd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.')
            })
        }
      }, (e) => {
        alert('Uw PRIM account wachtwoord kon niet gewijzigd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.')
      })
    }

    let div = document.createElement('div')
    div.className = 'viewport'

    let p = document.createElement('p')

    if (window.PRIM.License.isDemo) {
      p.innerHTML = 'In de demonstratieversie van PRIM is het niet mogelijk om het wachtwoord te wijzigen.'
    } else {
      p.innerHTML = 'Om uw wachtwoord te wijzigen, voer hieronder uw oude wachtwoord en 2 maal het nieuwe wachtwoord in. Het nieuwe wachtwoord moet vanwege veiligheid:'
    }    
    
    div.appendChild(p)

    if (!window.PRIM.License.isDemo) {
      let ul = document.createElement('ul')
      let li = document.createElement('li')    
      li.innerHTML = 'tenminste 12 tekens lang zijn'
      ul.appendChild(li)
      li = document.createElement('li')    
      li.innerHTML = 'tenminste 1 cijfer bevatten'
      ul.appendChild(li)
      li = document.createElement('li')    
      li.innerHTML = 'tenminste 1 hoofdletter bevatten'
      ul.appendChild(li)
      li = document.createElement('li')    
      li.innerHTML = 'tenminste 1 kleine letter bevatten'
      ul.appendChild(li)
      li = document.createElement('li')    
      li.innerHTML = 'tenminste 1 speciaal teken bevatten'
      ul.appendChild(li)

      div.appendChild(ul)

      p = document.createElement('p')
      p.innerHTML = 'Het gebruik van jaartalen, adres gegevens en namen is af te raden. Woorden zijn te gebruiken zolang ze onderling met elkaar en met u persoonlijk geen verband hebben. Dit zat niet gecontroleerd worden en u dient dit zelf na te gaan.'
      
      div.appendChild(p)

      let fieldset = document.createElement('fieldset')
      let legend = document.createElement('legend')
      legend.innerHTML = 'Uw PRIM account wachtwoord'
      fieldset.appendChild(legend)
      
      this.oldpassword = new PasswordControl(fieldset, {label: 'Oud wachtwoord'})
      this.password1 = new PasswordControl(fieldset, {label: 'Nieuw wachtwoord'})
      this.password2 = new PasswordControl(fieldset, {label: 'Nieuw wachtwoord herhalen'})

      let button = document.createElement('button')
      button.innerHTML = 'Account wachtwoord wijzigen'
      button.onclick = checkCredentials    

      div.appendChild(fieldset)

      div.appendChild(button)
    }
    
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/ChangeCredentials.js